(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/shared-components/consent-info.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/shared-components/consent-info.js');
'use strict';

const ConsentInfo = () => React.createElement("p", {
  className: "margin-top-1"
}, "N\xE4r du anv\xE4nder denna tj\xE4nst godk\xE4nner du att din kontoinformation h\xE4mtas fr\xE5n din bank under 180 dagar utan att du beh\xF6ver identifiera dig. Alla ins\xE4ttningar signeras med Mobilt BankID.");
svs.accountservicesReact.deposit.swedbankExpress.sharedComponents.ConsentInfo = ConsentInfo;

 })(window);